module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dform_top"
    }
  }, [_c('div', {}, [(_vm.set_payment_view) ? _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticStyle: {
      "float": "right",
      "margin-top": "1em",
      "cursor": "pointer",
      "text-align": "center",
      "text-decoration": "underline",
      "color": "#22baae"
    },
    on: {
      "click": function($event) {
        _vm.set_payment_view = false;
        _vm.preview_form == true;
      }
    }
  }, [_vm._v("Back to Form")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((Object.keys(_vm.set_payment_details_data).length !== 0)) ? _c('div', [_c('div', {
    staticStyle: {
      "padding": "3em 0.2em"
    }
  }, [_c('h4', [_vm._v("Payment Details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h6', [_c('b', [_vm._v("Name")]), _c('br'), _c('br'), _vm._v("\r\n                                    " + _vm._s(_vm.set_payment_details_data.customerName) + "\r\n                                ")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 wn-h-list"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "line-height": "1.8"
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.set_payment_details_data.cndiscount_form_amount))])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.set_payment_details_data.cndiscount_form_commission))])]), _vm._v(" "), (Number(_vm.set_payment_details_data.cndiscount_form_stamp_duty) > 0) ? _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.set_payment_details_data.cndiscount_form_stamp_duty))])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.set_payment_details_data.total_amount))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prepSetCNdiscountPayment(_vm.set_payment_details_data)
      }
    }
  }, [_vm._v("Proceed")])])])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "text-align": "center",
      "text-decoration": "underline",
      "color": "#22baae"
    },
    on: {
      "click": function($event) {
        _vm.set_payment_view = false;
        _vm.preview_form == true;
      }
    }
  }, [_vm._v("Back to Form")])])]) : _c('div', {}, [(_vm.cndiscount_set_view == '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('b', [_vm._v("Duration: ")]), _vm._v("2 weeks")]) : _vm._e(), _vm._v(" "), (_vm.preview_form) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('a', {
    staticStyle: {
      "float": "right",
      "margin-top": "1em",
      "cursor": "pointer",
      "text-decoration": "underline",
      "color": "#22baae"
    },
    on: {
      "click": function($event) {
        _vm.preview_form = false;
      }
    }
  }, [_vm._v("Back to Form")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Caption")]), _c('br'), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.cndiscount.cndiscount_caption) + "\r\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Discount Code")]), _c('br'), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.cndiscount.cndiscount_code) + "\r\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Discount Description")]), _c('br'), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.cndiscount.cndiscount_description) + "\r\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Discount Claim Link")]), _c('br'), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.cndiscount.cndiscount_link) + "\r\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Start Date")]), _c('br'), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.cndiscount.cndiscount_start_date) + "\r\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "#22baae solid 1px"
    }
  }, [_c('h6', [_c('b', [_vm._v("Expiry Date")]), _c('br'), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.cndiscount.cndiscount_expiry_date) + "\r\n                            ")])])])])]) : _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [(!_vm.is_logged_in) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setReg
    }
  }, [_vm._v("\r\n                       Create your cityneeds account\r\n                    ")])]) : _c('div', {
    staticClass: "row"
  }, [((Object.keys(_vm.businesses).length > 1)) ? _c('div', [_c('h3', [_vm._v("Set up DiscountBazaar for "), _c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "color": "#22baae",
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.business.business_name))])]), _vm._v(" "), _c('label', [_vm._v("or change business")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business),
      expression: "business"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please select")]), _vm._v(" "), _vm._l((_vm.businesses), function(bz) {
    return _c('option', {
      domProps: {
        "value": bz
      }
    }, [_vm._v(_vm._s(bz.business_name))])
  })], 2)])]) : _vm._e(), _vm._v(" "), ((Object.keys(_vm.businesses).length == 1)) ? _c('div', {
    staticClass: "p20"
  }, [_c('h3', [_vm._v("Set up DiscountBazaar for "), _c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "color": "#22baae",
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.business.business_name))])]), _vm._v(" "), _c('div', [(!_vm.set_new_business) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setAddNewBusiness
    }
  }, [_vm._v("Or add another business")]) : _c('button', {
    staticClass: "btn btn-primary btn-xl",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setReload
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.businesses).length == 0) || _vm.set_new_business)) ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticClass: "p20 mb10"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Business Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.category),
      expression: "business.category"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Business Category")]), _vm._v(" "), _vm._l((_vm.businessCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.business_category_id
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.name),
      expression: "business.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.business.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.location),
      expression: "business.location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Wuse"
    },
    domProps: {
      "value": (_vm.business.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.location = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.address),
      expression: "business.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.business.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "map00"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.map),
      expression: "business.map"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Map"
    },
    domProps: {
      "value": (_vm.business.map)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.map = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "background-color": "#fff",
      "color": "#22baae",
      "border": "#22baae solid"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.view_info = true;
        _vm.toggleComponent('gmap01');
      }
    }
  }, [_vm._v("\r\n                                        How to get my Google Map Code "), _c('i', {
    staticClass: "fa fa-angle-up",
    staticStyle: {
      "font-size": "1.6em"
    }
  })]), _vm._v(" "), _vm._m(12)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Set up DiscountBazaar")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_caption),
      expression: "cndiscount.cndiscount_caption"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter the Caption or Title of Discount"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_code),
      expression: "cndiscount.cndiscount_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Unique Discount Code"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_description),
      expression: "cndiscount.cndiscount_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Describe your offer",
      "rows": "8"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Discount Claim Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_link),
      expression: "cndiscount.cndiscount_link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter the website or social media link that would be used to claim the discount in this format, e.g.  https://quickstew.com"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_link = $event.target.value
      }
    }
  })]), _vm._v(" "), (((_vm.cndiscount.cndiscount_payment_status != undefined))) ? _c('div', [(_vm.cndiscount.cndiscount_payment_status == 0) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_start_date),
      expression: "cndiscount.cndiscount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_expiry_date),
      expression: "cndiscount.cndiscount_expiry_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_expiry_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_expiry_date = $event.target.value
      }
    }
  })])]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(18), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_start_date),
      expression: "cndiscount.cndiscount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_expiry_date),
      expression: "cndiscount.cndiscount_expiry_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_expiry_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_expiry_date = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Normal Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_normal_price),
      expression: "cndiscount.cndiscount_normal_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_normal_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_normal_price = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Discount Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cndiscount.cndiscount_discount_price),
      expression: "cndiscount.cndiscount_discount_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cndiscount.cndiscount_discount_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cndiscount.cndiscount_discount_price = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('label', [_vm._v(" Add Media")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "type": "file",
      "id": "fileElem04",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.setOnFileChange($event, _vm.cndiscount)
      }
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), (((_vm.business.business_id > 0) && (_vm.business.business_location == ''))) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.location),
      expression: "business.location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg: Wuse"
    },
    domProps: {
      "value": (_vm.business.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.location = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (((_vm.business.business_id > 0) && (_vm.business.business_map == ''))) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(21), _vm._v(" "), ((_vm.business.map_lat && (_vm.business.map_lat != ''))) ? _c('div', {
    key: _vm.mapComponentKey
  }, [_c('p', [_vm._v("Map Set to: Points LT-"), _c('span', [_vm._v(_vm._s(_vm.business.map_lat))]), _vm._v("-LN-"), _c('span', [_vm._v(_vm._s(_vm.business.map_lng))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "map00"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.map),
      expression: "business.map"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Map Code"
    },
    domProps: {
      "value": (_vm.business.map)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.map = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "background-color": "#fff",
      "color": "#22baae",
      "border": "#22baae solid"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleComponent('gmap01');
      }
    }
  }, [_vm._v("\r\n                                            How to get my Google Map Code "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "1.6em"
    }
  })]), _vm._v(" "), _vm._m(23)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12 wn-pd0"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms_cn_agree),
      expression: "terms_cn_agree"
    }],
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "-3em",
      "float": "left"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms_cn_agree) ? _vm._i(_vm.terms_cn_agree, null) > -1 : (_vm.terms_cn_agree)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.terms_cn_agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms_cn_agree = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.terms_cn_agree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms_cn_agree = $$c
        }
      }
    }
  }), _vm._m(24)])]), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.process_loading) ? _c('div', {
    staticClass: "cx-loading-sm"
  }) : _vm._e(), _vm._v(" "), (_vm.terms_cn_agree) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addNewDiscounts
    }
  }, [_vm._v("Set up DiscountBazaar")]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (((_vm.set_payment_data.total_amount) && (_vm.set_payment_data.total_amount > 0))) ? _c('div', [_c('cnpayment-modal', {
    attrs: {
      "payment_data": _vm.set_payment_data,
      "payment_object": _vm.set_payment_object
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("DiscountBazaar Post Fee:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Processing Fee: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Above Threshold Limit Charge (ATLC):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Total Amount: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Business Category"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Business Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Google Map\r\n                                    "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("(please use the Google map to set the coordinates of your Business address)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "gmap01"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae dashed"
    }
  }, [_c('ol', [_c('li', [_vm._v("Click the button below "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#fff",
      "color": "#22baae",
      "border": "#22baae solid"
    },
    attrs: {
      "href": "https://google-map-generator.com/"
    }
  })]), _vm._v(" "), _c('li', [_vm._v("Enter your addres in the "), _c('span', [_vm._v("Enter your Address")]), _vm._v(" box")]), _vm._v(" "), _c('li', [_vm._v("Click on the "), _c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-weight": "bolder"
    }
  }, [_vm._v("Get HTML-Code")])]), _vm._v(" "), _c('li', [_vm._v("Copy the Code that appears and paste inside the box above")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Caption"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Discount Code"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Describe this Offer"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Start Date"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Expiry Date"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Start Date"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Expiry Date"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Map Location"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("(please use the Google map to set the coordinates of your Business address)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "gmap01"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae dashed",
      "margin-bottom": "2em"
    }
  }, [_c('ol', [_c('li', [_vm._v("Click the button below "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#fff",
      "color": "#22baae",
      "border": "#22baae solid"
    },
    attrs: {
      "href": "https://google-map-generator.com/",
      "target": "_blank"
    }
  }, [_vm._v("Get My Google Map Code")])]), _vm._v(" "), _c('li', [_vm._v("Enter your addres in the "), _c('span', [_vm._v("Enter your Address")]), _vm._v(" box")]), _vm._v(" "), _c('li', [_vm._v("Click on the "), _c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-weight": "bolder"
    }
  }, [_vm._v("Get HTML-Code")])]), _vm._v(" "), _c('li', [_vm._v("Copy the Code that appears and paste inside the box above")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-top": "-0.4em",
      "margin-left": "-1.4em",
      "float": "left",
      "font-size": "18px"
    }
  }, [_vm._v("Please accept "), _c('a', {
    attrs: {
      "href": "/terms"
    }
  }, [_vm._v("Terms")]), _vm._v(" to submit")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09552e6b"}!./src/templates/CNdiscountForm/template.html
// module id = 267
// module chunks = 0